import { useQuery } from '@tanstack/react-query'
import { ResponseApiError } from '../../../models/axios-error'
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { UseQueryOptionsWithoutQueryKey } from '../../../react-query-config'
import { Channel, AggregationLevel } from '../home.model'

export interface UseApiGetProductivityRequest {
  channel: Channel
  aggregation: AggregationLevel
  storeId: number
  teamId: number | null
}

export interface ProductivityValues {
  realizedGmv: number | null
  spentHours: number | null
}

const getProductivity = async (config: AxiosRequestConfig): Promise<ProductivityValues> => {
  const axiosPromise: AxiosResponse<ProductivityValues> = await axios(config)
  return {
    realizedGmv: axiosPromise.data?.realizedGmv,
    spentHours: axiosPromise.data?.spentHours
  }
}

export const useApiGetProductivity = (
  args: UseApiGetProductivityRequest,
  enabled: boolean,
  options?: UseQueryOptionsWithoutQueryKey<ProductivityValues>
) => {
  const { storeId, teamId, channel, aggregation } = args
  const teamParam = aggregation === 'TEAM' && teamId !== null ? `&teamId=${teamId}` : ''
  const url = `/productivity?aggregation=${aggregation}&channel=${channel}&storeId=${storeId}${teamParam}`
  const config: AxiosRequestConfig = { method: 'get', url }

  return useQuery<ProductivityValues, ResponseApiError>({
    queryKey: ['get-productivity', url],
    queryFn: () => getProductivity(config),
    enabled,
    ...options
  })
}
